import React, { useEffect, useRef } from 'react';
import { Button } from '~/shared/Theme';
import { Caption } from '~/shared/Typography';

const ResendCodeButton = React.memo(({
    countdown,
    disabled,
    handleResendCode,
    isResendCode,
    buttonTextColor,
    t,
    onCountdownComplete,
}: {
    countdown: number;
    disabled: boolean;
    handleResendCode: () => void;
    isResendCode: boolean;
    buttonTextColor: string;
    t: (key: string, values?: unknown[]) => string;
    onCountdownComplete: () => void;
}) => {

    const previousCountdown = useRef(countdown);

    useEffect(() => {

        if (
            previousCountdown.current > 0 &&
            countdown === 0 &&
            disabled
        ) {
            onCountdownComplete();
        }

        previousCountdown.current = countdown;
    }, [countdown, disabled, onCountdownComplete]);

    return (
        <Button
            disabled={disabled}
            onPress={handleResendCode}
            px={4}
            py={2}
            textAlign={'center'}
        >
            <Caption
                fontFamily={'Helvetica'}
                color={buttonTextColor}
                textAlign={'center'}
            >
                { disabled && countdown !== 0
                    ? t('loginTemplate.resend_code_countdown', [countdown])
                    : isResendCode ? t('loginTemplate.resend_code') : t('loginTemplate.resend_code_cta')
                }
            </Caption>
        </Button>
    );
});

ResendCodeButton.displayName = 'ResendCodeButton';


export default ResendCodeButton;
